module.exports = __webpack_public_path__ + "static/aboutsandy-credential-bcc-min-c622008f5dc8b4a596e861422bea4918.png";